import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[DateToCurrentYear]"
})
export class YearSelectorDirective {
  @HostListener("blur", ["$event"]) onBlur() {
    let currentValue = this.ngControl.value;
    let dateUserEntered = new Date(currentValue);
    let year = dateUserEntered.getFullYear();
    let month = dateUserEntered.getMonth() + 1; //0 based so need to add 1 to get actual month number
    let day = dateUserEntered.getDate();
    let updatedDate: Date;
    let currentYear: number = new Date().getFullYear();

    if(year === 2001){

        updatedDate = new Date(`${month}/${day}/${currentYear}`);
        this.ngControl.control?.setValue(updatedDate);
    }
    
    
  }

  constructor(
    private ngControl: NgControl) {}
}